import React from 'react';
import style from '../../css/Whycard_two.module.css';

function Whycard_two() {
	const images = [
		'https://www.ahstatic.com/photos/6790_ho_00_p_1024x768.jpg',
		'https://blogimage.vantagecircle.com/content/images/2024/01/13-Corporate-Reward-Programs-with-Essentials--Benefits--Ideas--and-Steps.png',
		'https://media.istockphoto.com/id/912322946/photo/convenient-way-of-payment.jpg?s=612x612&w=0&k=20&c=dLiM1LqGllJs6aOZInNwObJcvqxjz1nJk7nw6me2JW0=',
		,
	];

	const benefits = [
		{
			title: 'Loyalty compatible',
			desc: 'Employees earn miles and points as if booking directly with suppliers. They can filter results by membership and see what they’ll earn.',
		},
		{
			title: 'Exclusive Exporest Rewards',
			desc: 'Incentivize smart choices with personal travel credits — 100% funded by Exporest — when travelers pick cost-effective options.',
		},
		{
			title: 'Easy leisure extensions',
			desc: 'Let employees extend business trips using personal cards, which keeps business and leisure expenses clear-cut.',
		},
	];

	return (
		<div className={style.container}>
			<div className={style.header}>
				<h2>Why your teams will love Exporest</h2>
				<p>
					A sleek, mobile-first tool packed with perks to drive high adoption.
				</p>
			</div>

			<div className={style.cardGrid}>
				{images.map((image, i) => (
					<div key={i} className={style.cardColumn}>
						<div className={style.benefitItem}>
							<h1>{i + 1}</h1>
							<div>
								<h4>{benefits[i].title}</h4>
								<p>{benefits[i].desc}</p>
							</div>
							<div className={style.card}>
								<img
									src={image}
									alt={`Image ${i + 1}`}
									className={style.cardImage}
								/>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default Whycard_two;
